import { attr, belongsTo } from "@ember-data/model";
import dayjs from "dayjs";
import {
  validateDate,
  validateInclusion,
  validatePresence
} from "ember-changeset-validations/validators";
import type { IntlService } from "ember-intl";
import type ConsultationFrequency from "parog-web/models/consultation/consultation-frequency";
import JournalEvent from "parog-web/models/journal-event";
import tWithDefault from "parog-web/utils/t-with-default";
import type Patient from "./patient";

//---- Automatically generated, don't update this part ----

type SourceStringEnum = "profiler" | "wise";

export default class ConsultationFrequencyChangedJournalEvent extends JournalEvent {
  static override type = "consultation-frequency-changed-journal-event";

  @attr("string") declare source: SourceStringEnum;

  static override validations(intl: IntlService) {
    return {
      occurredAt: [
        validatePresence({
          presence: true,
          description: tWithDefault(
            intl,
            "validations.consultation-frequency-changed-journal-event.occurred-at",
            "La date"
          )
        }),
        validateDate({
          message:
            "Cette donnée ne peut être déclarée avant 1900. Veuillez modifier la date",
          onOrAfter: new Date("01/01/1900")
        }),
        validateDate({
          message:
            "Cette donnée ne peut être déclarée dans le futur. Veuillez modifier la date",
          onOrBefore: dayjs().endOf("day").toDate()
        })
      ],
      source: validateInclusion({
        list: ["profiler", "wise"],
        allowBlank: true,
        description: intl.t(
          "validations.consultation-frequency-changed-journal-event.source"
        )
      })
    };
  }

  //---- End of generated code ----

  @attr("consultation-frequencies", {
    defaultValue() {
      return [];
    }
  })
  declare consultationFrequencies: ConsultationFrequency[];

  @belongsTo("patient", {
    async: false,
    inverse: "consultationFrequencyChangedJournalEvent"
  })
  declare patient: Patient;
}

// DO NOT DELETE: this is how TypeScript knows how to look up your models.
declare module "ember-data/types/registries/model" {
  export default interface ModelRegistry {
    "consultation-frequency-changed-journal-event": ConsultationFrequencyChangedJournalEvent;
  }
}
